import { mapGetters } from "vuex";
import { validationMixin } from 'vuelidate'
import { required, maxLength, email } from 'vuelidate/lib/validators' 

export default {
  mixins: [validationMixin],
  validations: {
    select:{
      // email: { required, email },
      // name: { required },
      text: { required },
      region: { required}, 
      phone: { required, maxLength: maxLength(17) },
    }
  },
  data: () => ({
    dialog: false,
    isComplite: false,
    isAuth: false,
    regions: [],
    select:{
      name: null,
      email: null,
      phone: null,
      text: null,
      file: null,
      region: []
    }
  }),

  methods: {
    modal(){
      this.select.text = null;
      this.select.file = null;
      this.isComplite = false;
      this.select.name = null;
      this.select.email = null;
      this.select.region = [];
      this.dialog = !this.dialog;
      this.$axios
        .get("auth/registration/atribute")
        .then((res) => {
          if (res.data.cod == 200) {
            this.regions = res.data.result.region;
          }
        })
    },
    closse(){
      this.dialog = false;
    },
    fileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.select.file = files[0];
    },
    send(){
      this.$v.select.$touch();
      if(this.$v.select.$invalid){
        return;
      } 
      
      let formData = new FormData();
      for ( var key in this.select ) {
        formData.append(key, this.select[key]);
      }
      this.$axios.post('chat/new/feeze', 
      formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      } 
      ).then(res => {
        if(res.data.cod == 200){
          this.select = {
            name: null,
            email: null,
            phone: null,
            id: null,
            text: null,
            file: null,
            region: []
          };
          this.isComplite = true;
          if(!this.isAuth){
            this.setToken({token: res.data.result.access_token, isRemember: true});
            this.setUser = res.data.result.user;
            this.closse();
            location.reload();
          }
        }
      }).finally(() => {
      });
    }
  },
  mounted() {
    this.$root.$on('modal.applying', () => {
      this.modal();
    });
  },
  computed:{
    phoneErrors () {
      const errors = []
      if (!this.$v.select.phone.$dirty) return errors
      !this.$v.select.phone.maxLength && errors.push('Неккоректный номер')
      !this.$v.select.phone.required && errors.push('Обязательное поле')
      return errors
    },
    emailErrors () {
      const errors = []
      if (!this. $v.select.email.$dirty) return errors
      !this. $v.select.email.email && errors.push('Неккоректный e-mail')
      !this. $v.select.email.required && errors.push('Обязательное поле')
      return errors
    },
    nameErrors () {
      const errors = []
      if (!this.$v.select.name.$dirty) return errors
      !this. $v.select.name.required && errors.push('Обязательное поле')
      return errors
    },
    regionErrors () {
      const errors = []
      if (!this.$v.select.region.$dirty) return errors
      !this. $v.select.region.required && errors.push('Обязательное поле')
      return errors
    },
    textErrors () {
      const errors = []
      if (!this.$v.select.text.$dirty) return errors
      !this. $v.select.text.required && errors.push('Обязательное поле')
      return errors
    },
    ...mapGetters(['getUser']),
  },
  watch: {
    isComplite(to, from){
      if(to){
        setTimeout(()=>{
          this.select.text = null;
          this.select.file = null;
          this.isComplite = false;
          this.select.name = null;
          this.select.email = null;
          this.select.region = [];
          this.dialog = !this.dialog;
      },3000);
      }
    },
    getUser(to, from) {
      this.select.email = this.getUser.email;
      this.select.name = this.getUser.name;
      this.select.phone = this.getUser.phone;
      this.isAuth = true;
    },
  },
};


// WEBPACK FOOTER //
// ./src/modals/applying/applying.js